import { useEffect, useRef } from 'preact/hooks';

// Simple declaration for the global tippy function
declare global {
   interface Window {
      tippy: any; // You can make this stricter if you want, but 'any' is fine for now
   }
}

interface TooltipProps {
   content: string;
   children: any;
}

/**
 * Tiny Preact wrapper to call Tippy (already live on all site pages.)
 */
export function Tooltip({ content, children }: TooltipProps) {
   const elRef = useRef<HTMLDivElement>(null);

   useEffect(() => {
      if (!elRef.current || !window.tippy) return;

      // 1. Initialize Tippy on the specific DOM node
      const instance = window.tippy(elRef.current, {
         content: content,
         theme: 'light',
         // Add any other global options you want here
         // animation: 'scale',
      });

      // 2. Cleanup: Destroy the tippy instance when this component unmounts
      // This is crucial! Otherwise, if the user navigates away or the
      // card collapses, the tooltip listeners hang around.
      return () => {
         // Tippy returns an array if you pass a selector,
         // but a single instance if you pass a DOM node.
         // Safely handle both or just assume single instance:
         if (instance.destroy) {
            instance.destroy();
         } else if (instance[0] && instance[0].destroy) {
            instance[0].destroy();
         }
      };
   }, [content]); // Re-run if the tooltip text changes

   // Render the child, wrapping it if necessary, or attaching ref directly
   return (
      // class ideas: "underline decoration-dotted cursor-help"
      <span ref={elRef}>
         {children}
      </span>
   );
}
